import {UPDATE_BUILD_BUNDLES_VALUES, REQUEST_BUILD_BUNDLES, RECEIVE_BUILD_BUNDLES, CLEAR_BUILD_BUNDLES_VALUES} from '../constants/actionTypes';

const bundlesInitialState = {
    branchName: "",

    branchNameValid: false,
    isRequestingBuild: false
};

export const bundleData = (state = bundlesInitialState, action) => {
    switch(action.type) {
        case UPDATE_BUILD_BUNDLES_VALUES:
            return {
                ...state,
                ...action.values
            };

        case REQUEST_BUILD_BUNDLES:
            return {
                ...state,
                isRequestingBuild: true
            };
        
        case RECEIVE_BUILD_BUNDLES:
            return {
                ...state,
                isRequestingBuild: false
            };
        
        case CLEAR_BUILD_BUNDLES_VALUES:
            return bundlesInitialState;
        
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/bundleData.js